// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-snackbar.lit.scss INSTEAD!
import { css } from 'lit';
export default css`:root {
  /* 
   * @cssprop [--sh-snackbar-min-height=2.5rem] - Minimum height of the snackbar
   */
  --sh-snackbar-min-height: 2.5rem;
  /* 
   * @cssprop [--sh-snackbar-max-height=2.5rem] - Maximum height of the snackbar
   */
  --sh-snackbar-max-height: 2.5rem;
  /* 
   * @cssprop [--sh-snackbar-content-gap=0.25rem] - Gap between content elements
   */
  --sh-snackbar-content-gap: 0.25rem;
  /* 
   * @cssprop [--sh-snackbar-padding-left=0.5rem] - Left padding of the snackbar
   */
  --sh-snackbar-padding-left: 0.5rem;
  /* 
   * @cssprop [--sh-snackbar-padding-top=0.25rem] - Top padding of the snackbar
   */
  --sh-snackbar-padding-top: 0.25rem;
  /* 
   * @cssprop [--sh-snackbar-padding-right=0.25rem] - Right padding of the snackbar
   */
  --sh-snackbar-padding-right: 0.25rem;
  /* 
   * @cssprop [--sh-snackbar-padding-bottom=0.25rem] - Bottom padding of the snackbar
   */
  --sh-snackbar-padding-bottom: 0.25rem;
  /* 
   * @cssprop [--sh-snackbar-label-margin-left=0.25rem] - Left margin of the label
   */
  --sh-snackbar-label-margin-left: 0.25rem;
  /* 
   * @cssprop [--sh-snackbar-label-margin-right=0.5rem] - Right margin of the label
   */
  --sh-snackbar-label-margin-right: 0.5rem;
  /* 
   * @cssprop [--sh-snackbar-label-margin-top=0] - Top margin of the label
   */
  --sh-snackbar-label-margin-top: 0;
  /* 
   * @cssprop [--sh-snackbar-label-margin-bottom=0] - Bottom margin of the label
   */
  --sh-snackbar-label-margin-bottom: 0;
  /* 
   * @cssprop [--sh-snackbar-button-margin-left=0] - Left margin of the button
   */
  --sh-snackbar-button-margin-left: 0;
  /* 
   * @cssprop [--sh-snackbar-button-margin-top=0] - Top margin of the button
   */
  --sh-snackbar-button-margin-top: 0;
  /* 
   * @cssprop [--sh-snackbar-button-margin-right=0] - Right margin of the button
   */
  --sh-snackbar-button-margin-right: 0;
  /* 
   * @cssprop [--sh-snackbar-button-margin-bottom=0] - Bottom margin of the button
   */
  --sh-snackbar-button-margin-bottom: 0;
  /* 
   * @cssprop [--sh-snackbar-button-padding-left-right=0.5rem] - Horizontal padding of the button
   */
  --sh-snackbar-button-padding-left-right: 0.5rem;
  /* 
   * @cssprop [--sh-snackbar-button-height=2rem] - Height of the button
   */
  --sh-snackbar-button-height: 2rem;
  /* 
   * @cssprop [--sh-snackbar-loading-spinner-size=1.5rem] - Size of the loading spinner
   */
  --sh-snackbar-loading-spinner-size: 1.5rem;
  /* 
   * @cssprop [--sh-snackbar-loading-spinner-border=0.125rem] - Border width of the loading spinner
   */
  --sh-snackbar-loading-spinner-border: 0.125rem;
  /* 
   * @cssprop [--sh-snackbar-border-radius=var(--sh-radius-small-container)] - Border radius of the snackbar
   */
  --sh-snackbar-border-radius: var(--sh-radius-small-container);
  /* 
   * @cssprop [--sh-snackbar-close-margin-right=0.25rem] - Right margin of the close button
   */
  --sh-snackbar-close-margin-right: 0.25rem;
}

:host {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: var(--sh-snackbar-padding-top) var(--sh-snackbar-padding-right) var(--sh-snackbar-padding-bottom) var(--sh-snackbar-padding-left);
  min-height: var(--sh-snackbar-min-height);
  max-height: var(--sh-snackbar-max-height);
  min-width: var(--sh-public-snackbar-min-width, auto);
  max-width: var(--sh-public-snackbar-max-width, calc(100% - 2 * var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance))));
  color: var(--text-primary);
  background-color: var(--base-4);
  border-radius: var(--sh-radius-small-container);
  box-shadow: var(--shadow-overlay);
  width: max-content;
  height: auto;
  margin: auto;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  gap: var(--sh-snackbar-content-gap);
  z-index: 10000;
  animation: snackbar-enter 0s var(--sh-snackbar-animation-easing, cubic-bezier(0.16, 1, 0.3, 1)) forwards;
}

:host(.top-left),
:host(.top-center),
:host(.top-right) {
  animation-name: snackbar-enter-from-top;
}

:host(.bottom-left),
:host(.bottom-center),
:host(.bottom-right) {
  animation-name: snackbar-enter-from-bottom;
}

@keyframes snackbar-enter-from-top {
  from {
    opacity: 0;
    transform: translateY(-100%) translateX(var(--center-offset, 0));
    filter: blur(0.25rem);
  }
  to {
    opacity: 1;
    transform: translateY(0) translateX(var(--center-offset, 0));
    filter: blur(0rem);
  }
}
@keyframes snackbar-enter-from-bottom {
  from {
    opacity: 0;
    transform: translateY(100%) translateX(var(--center-offset, 0));
    filter: blur(0.25rem);
  }
  to {
    opacity: 1;
    transform: translateY(0) translateX(var(--center-offset, 0));
    filter: blur(0rem);
  }
}
@keyframes snackbar-enter {
  from {
    opacity: 0;
    transform: scale(0.95) translateX(var(--center-offset, 0));
    filter: blur(0.125rem);
  }
  to {
    opacity: 1;
    transform: scale(1) translateX(var(--center-offset, 0));
    filter: blur(0rem);
  }
}
:host(.top-left) {
  position: fixed;
  top: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: auto;
  bottom: auto;
  --center-offset: 0;
}

:host(.parent-target).top-left {
  position: absolute;
  top: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: auto;
  bottom: auto;
  --center-offset: 0;
}

:host(.top-center) {
  position: fixed;
  top: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: 50%;
  right: auto;
  bottom: auto;
  --center-offset: -50%;
  transform: translateX(-50%);
}

:host(.parent-target).top-center {
  position: absolute;
  top: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: 50%;
  right: auto;
  bottom: auto;
  --center-offset: -50%;
  transform: translateX(-50%);
}

:host(.top-right) {
  position: fixed;
  top: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: auto;
  bottom: auto;
  --center-offset: 0;
}

:host(.parent-target).top-right {
  position: absolute;
  top: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: auto;
  bottom: auto;
  --center-offset: 0;
}

:host(.bottom-left) {
  position: fixed;
  bottom: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: auto;
  top: auto;
  --center-offset: 0;
}

:host(.parent-target).bottom-left {
  position: absolute;
  bottom: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: auto;
  top: auto;
  --center-offset: 0;
}

:host(.bottom-center) {
  position: fixed;
  bottom: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: 50%;
  right: auto;
  top: auto;
  --center-offset: -50%;
  transform: translateX(-50%);
}

:host(.parent-target).bottom-center {
  position: absolute;
  bottom: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: 50%;
  right: auto;
  top: auto;
  --center-offset: -50%;
  transform: translateX(-50%);
}

:host(.bottom-right) {
  position: fixed;
  bottom: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: auto;
  top: auto;
  --center-offset: 0;
}

:host(.parent-target).bottom-right {
  position: absolute;
  bottom: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  right: var(--sh-public-snackbar-edge-distance, var(--sh-snackbar-edge-distance, 1rem));
  left: auto;
  top: auto;
  --center-offset: 0;
}

@media (prefers-reduced-motion: reduce) {
  :host {
    animation-duration: 0s;
  }
  @keyframes snackbar-enter-from-top {
    from {
      opacity: var(--opacity-0);
    }
    to {
      opacity: var(--opacity-1);
    }
  }
  @keyframes snackbar-enter-from-bottom {
    from {
      opacity: var(--opacity-0);
    }
    to {
      opacity: var(--opacity-1);
    }
  }
  @keyframes snackbar-enter {
    from {
      opacity: var(--opacity-0);
    }
    to {
      opacity: var(--opacity-1);
    }
  }
}
.type-icon,
::slotted([slot=icon]) {
  flex-shrink: 0;
  margin-left: var(--sh-snackbar-icon-leading-margin-left);
}

::slotted([slot=icon]) {
  color: var(--icon-color, inherit);
}

.label {
  flex-grow: 1;
  margin: var(--sh-snackbar-label-margin-top) var(--sh-snackbar-label-margin-right) var(--sh-snackbar-label-margin-bottom) var(--sh-snackbar-label-margin-left);
  font: var(--body-1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
}

.action {
  cursor: pointer;
  padding: 0 var(--sh-snackbar-button-padding-left-right);
  height: var(--sh-snackbar-button-height);
  border: none;
  border-radius: var(--sh-radius-control);
  background: none;
  transition: background-color var(--transition-time);
  font: var(--title-1);
  font-weight: bold;
  color: var(--color-text-strong);
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 12rem;
  flex-shrink: 0;
  flex-grow: 0;
}

.action:focus-visible {
  outline: var(--focus-outline);
  outline-offset: -0.125rem;
  box-shadow: none;
}

@media (hover) {
  .action:hover {
    background: rgba(var(--ui-1), var(--opacity-50));
  }
}
.action:active {
  background: rgba(var(--ui-1), var(--opacity-100));
}

.close-button {
  margin: 0 var(--sh-snackbar-close-margin-right) 0 0;
}`;